import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
export const UserAutoCompleteDisplay = ({ props, option }) => {
    return (_createElement("li", Object.assign({}, props, { key: `${option.displayName} ${option.email}` }),
        _jsxs("span", { children: [option.displayName, " ", _jsx("br", {}), _jsx("small", { children: option.email })] })));
};
